import $ from 'cash-dom';
import { matchBelowLg } from '../media';

/**
 * This module fixes the background gradient on the home page
 * This is very hardcoded quickfix. Apologies to future you if you have to fix this.
 */
export default class HomefixModule {

    static name = 'homefix';

    constructor() {

        if(!$('body').hasClass('page-1030')) return;
        this.addWrapper();
    }

    /**
     * wrap all blocks up to the first ".bg-brand-gray1" with a div
     */
    addWrapper = () => {
        const $blocks = $('main > .b');
        const endIndex = $blocks.filter('.bg-brand-gray1').index();
        if($blocks.length && endIndex > 0) {
            $blocks.slice(0, endIndex).wrapAll('<div class="homefix"></div>');
        }
    }
}